import React from 'react'
import { CSVLink } from "react-csv";
import { normalizePhone } from '../../utils/functions/tools/normalizePhone';
import {
  DataTable,
  Table,
  Link,
  Button,
  Pagination,
  TableBatchAction,
  TableBatchActions,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableSelectAll,
  TableSelectRow,
  TableToolbar,
  TableToolbarAction,
  TableToolbarContent,
  TableToolbarSearch,
  TableToolbarMenu,
  Tag,
  Modal,
  NotificationActionButton,
  InlineNotification
} from 'carbon-components-react';
import {
  Delete16 as Delete,
  Save16 as Save,
  Download16 as Download,
} from '@carbon/icons-react';

const clientListHeaders = [
  { header: "ID", key: "id" },
  { header: "First Name", key: "fname" },
  { header: "Last Name", key: "lname" },
  { header: "Email Address", key: "email" },
  { header: "Signed Date", key: "signeddate" }
];

export default {
  title: 'Components/DataTable/Batch Actions',
  component: DataTable,
  subcomponents: {
    TableBatchAction,
    TableBatchActions,
    TableToolbar,
    TableToolbarAction,
    TableToolbarContent,
    TableToolbarSearch,
    TableToolbarMenu,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
  },
};

export const AgreementsList = ({ clientListReport, setClientsToDel, clientsToDel, error, setError, setOpenDeleteModal, openDeleteModal, batchDelete, rows, totalItems, currentPageSize, setCurrentPageSize, setFirstRowIndex, setClientSearch }: any) => (
  <>
    <DataTable rows={rows} headers={clientListHeaders} isSortable>
      {({
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getSelectionProps,
        getToolbarProps,
        getBatchActionProps,
        onInputChange,
        selectedRows,
        getTableProps,
        getTableContainerProps,
      }) => {
        const batchActionProps = getBatchActionProps();
        return (
          <TableContainer
            title="Submission List"
            description="List of all submissions in the system."
            {...getTableContainerProps()}>
            <TableToolbar {...getToolbarProps()}>
              <TableBatchActions {...batchActionProps}>
                <TableBatchAction
                  tabIndex={batchActionProps.shouldShowBatchActions ? 0 : -1}
                  renderIcon={Delete}
                  onClick={() => setOpenDeleteModal(true) & setClientsToDel(selectedRows)}
                >
                  Delete
                </TableBatchAction>
              </TableBatchActions>
              <TableToolbarContent
                aria-hidden={batchActionProps.shouldShowBatchActions}>
                <TableToolbarSearch
                  persistent={true}
                  tabIndex={batchActionProps.shouldShowBatchActions ? -1 : 0}
                  onChange={(e) => setClientSearch(e.target.value)}
                  placeholder="Search submissions"
                />
                <TableToolbarMenu
                  tabIndex={batchActionProps.shouldShowBatchActions ? -1 : 0}>
                  <TableToolbarAction>
                    <CSVLink className="text-dark dec-none" {...clientListReport}>Export to CSV</CSVLink>
                  </TableToolbarAction>
                </TableToolbarMenu>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  <TableSelectAll {...getSelectionProps()} />
                  {headers.map((header, i) => (
                    <TableHeader key={i} {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow key={i} {...getRowProps({ row })}>
                    <TableSelectRow {...getSelectionProps({ row })} />
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {cell.info.header === "fname" ? <Link href={`/submissions/${row.id}`}>{cell.value}</Link>
                          : cell.info.header === "lname" ? <Link href={`/submissions/${row.id}`}>{cell.value}</Link> 
                          : cell.info.header === "id" ? <Link href={`/submissions/${row.id}`}>{cell.value}</Link> 
                          : cell.info.header === "email" ? <Link href={`mailto:${cell.value}`}>{cell.value}</Link> : cell.value}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Pagination
              totalItems={totalItems}
              pageSizes={[10, 20, 30, 40, 50]}
              pageSize={currentPageSize}
              onChange={({ page, pageSize }) => {
                if (pageSize !== currentPageSize) {
                  setCurrentPageSize(pageSize);
                }
                setFirstRowIndex(pageSize * (page - 1));
              }}
            />
          </TableContainer>
        );
      }}
    </DataTable>

    <Modal
      danger
      open={openDeleteModal}
      modalHeading="Delete Submission(s)"
      modalLabel="Submission List"
      primaryButtonText="Delete Submission(s)"
      secondaryButtonText="Cancel"
      onRequestClose={() => setOpenDeleteModal(false) & setError(false)}
      onRequestSubmit={() => batchDelete(clientsToDel)}
    >
      {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to delete submission(s)" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
      <p>Are you sure you want to delete the selected submission(s)?</p>
    </Modal>
  </>
);